import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { SmartPeriodSelector } from '@/components/ui/SmartPeriodSelector'
import { getUserSelectablePlatforms } from '@/constants/platforms'

interface ConfigurationStepProps {
  selectedPlatform: string
  selectedPeriod: string
  onPlatformChange: (platform: string) => void
  onPeriodChange: (period: string) => void
  fileName: string
}

export function ConfigurationStep({
  selectedPlatform,
  selectedPeriod,
  onPlatformChange,
  onPeriodChange,
  fileName
}: ConfigurationStepProps) {
  const platformOptions = getUserSelectablePlatforms()

  return (
    <div className="space-y-6">
      {/* Configuration Form */}
      <div className="space-y-6">
        {/* Platform Selection */}
        <div className="space-y-2">
          <label className="text-sm font-medium">
            Plattform <span className="text-red-500">*</span>
          </label>
          <Select value={selectedPlatform} onValueChange={onPlatformChange}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Välj plattform" />
            </SelectTrigger>
            <SelectContent>
              {platformOptions.map(platform => (
                <SelectItem key={platform.value} value={platform.value}>
                  {platform.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <p className="text-xs text-muted-foreground">
            Välj vilken plattform denna fil kommer från
          </p>
        </div>

        {/* Period Selection */}
        <div className="space-y-2">
          <label className="text-sm font-medium">
            Period <span className="text-red-500">*</span>
          </label>
          <SmartPeriodSelector
            value={selectedPeriod}
            onChange={onPeriodChange}
            storageKey="upload-workflow-last-period"
            required
          />
          <p className="text-xs text-muted-foreground">
            Välj vilken tidsperiod denna data gäller för
          </p>
        </div>
      </div>
    </div>
  )
}
